import React, { useState, useContext } from "react"
import Helmet from "react-helmet"

import { ModalContext } from "../../StateProvider"

import "./CookiesModal.scss"

const CookiesModal = () => {
  const [statistiken, setStatistiken] = useState(false)
  const [marketing, setMarketing] = useState(false)
  const [modal, setModal] = useContext(ModalContext)

  const handleStat = () => {
    setStatistiken(!statistiken)
  }

  const handleMark = () => {
    setMarketing(!marketing)
  }

  const modalHandeler = () => {
    setModal(!modal)
  }

  return (
    <>
      {modal ? (
        <div className="cookie-container">
          {/* <Helmet
            bodyAttributes={{
              class: "overflow-body",
            }}
          /> */}
          <div className="cookie-bg"></div>
          <div className="cookie-content-container">
            <div className="cookie-content">
              <h1>Datenschutzeinstellungen</h1>
              <p className="cookie-text">
                Wir nutzen Cookies auf unserer Website. Einige von ihnen sind
                essenziell, während andere uns helfen, diese Website und Ihre
                Erfahrung zu verbessern.
              </p>

              <div className="cookie-check-box">
                <div className="cookie-auswahl">
                  <div className="cookie-auswahl-item">
                    <div className="check activate-check"></div>
                    <p>Essenziell</p>
                  </div>
                </div>

                <div className={`cookie-auswahl`} onClick={handleStat}>
                  <div className="cookie-auswahl-item">
                    <div
                      className={`check ${
                        statistiken ? "activate-check" : null
                      }`}
                    ></div>
                    <p>Statistiken</p>
                  </div>
                </div>

                <div className={`cookie-auswahl`} onClick={handleMark}>
                  <div className="cookie-auswahl-item">
                    <div
                      className={`check ${marketing ? "activate-check" : null}`}
                    ></div>
                    <p>Marketing</p>
                  </div>
                </div>
              </div>

              <div className="cookie-btn">
                <button onClick={modalHandeler} className="akzeptieren">
                  Alle akzeptieren
                </button>
                <button onClick={modalHandeler} className="speichern">
                  Speichern
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}

export default CookiesModal
